enum UserProfileTab {
  PROJECT_DETAILS = 'project_details',
  MFA_SECURITY = 'mfa_security',
}

export default UserProfileTab;
